import { Button } from '../button.js';

export const OutputButton = ({
  disabled,
  onLabel,
  state
}: {
  disabled?: boolean;
  state: 'idle' | 'in-progress' | 'starting' | 'stopping';
  onLabel?: () => void;
}) => {
  const newState = state === 'starting' || state === 'stopping' ? 'in-progress' : state;

  return (
    <Button
      disabled={disabled}
      state={newState}
      label={
        state === 'starting'
          ? 'Starting...'
          : state === 'stopping'
            ? 'Stopping...'
            : state === 'idle'
              ? 'Start Output'
              : 'Stop All Outputs'
      }
      onLabel={onLabel}
    />
  );
};
